import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import { request } from "@/js/http/http_request";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { casingForAdmin } from "@/js/wine/wine.js";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms";
import { getIdCurrencyUsedForCartAndExplore, formatPrice } from "@/js/currency/currencies.js";
import { listCurrencies, casingWines, orderStatus, buyLimitErrors } from "@/js/lists.ts";
import WineNaming from "@/components/products/WineNaming.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "Cart",
  components: {
    confirm: confirmationComponent,
    "wine-naming": WineNaming,
    WineDiscountTooltip: WineDiscountTooltip,
    ErrorModal: ErrorModal
  },
  props: ["loggedUserData", "areAllItemsAddedToCart"],
  data: function data() {
    return {
      imagesBroken: [],
      actionsItem: [],
      isRemovingCart: false,
      countdownElapsed: false,
      timelapseDuration: orderHandler.CART_HOURS_TIMELAPSE,
      quantityToggleKey: false,
      order: {
        id_order: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        taxes: null,
        payment_fee: null,
        status: null,
        creatorUserId: null
      },
      currency: "",
      managedExceptions: {
        dialogReload: {
          ITEM_NOT_IN_ORDER: "Item not in your cart anymore"
        }
      },
      listCurrencies: listCurrencies,
      casingWines: casingWines,
      filterIntegerKey: filterIntegerKey,
      isAdminNotConsultant: isAdminNotConsultant,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isACart: function isACart() {
      var _this$order, _this$order2;
      return ((_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.creatorUserId) === +this.loggedUserData.idUser && ((_this$order2 = this.order) === null || _this$order2 === void 0 ? void 0 : _this$order2.status) === orderStatus.find(function (os) {
        return os.id == "CREATED";
      }).status;
    },
    hasItems: function hasItems() {
      var _this$order3;
      return ((_this$order3 = this.order) === null || _this$order3 === void 0 || (_this$order3 = _this$order3.items) === null || _this$order3 === void 0 ? void 0 : _this$order3.length) > 0;
    },
    isGreatExport: function isGreatExport() {
      var _this$order4;
      return !((_this$order4 = this.order) !== null && _this$order4 !== void 0 && (_this$order4 = _this$order4.delivery_address) !== null && _this$order4 !== void 0 && (_this$order4 = _this$order4.country) !== null && _this$order4 !== void 0 && _this$order4.european_union_member);
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order$items;
      return this.order.amount_vat > 0 || this.isOrderForIndividualUs && ((_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.some(function (x) {
        return x.total_amount - x.amount_ex_vat > 0;
      }));
    },
    isBypassBuyLimitMessageAvailable: function isBypassBuyLimitMessageAvailable() {
      return this.isAdminNotConsultant && this.order.isBypassBuyLimits;
    },
    isEditingAnItem: function isEditingAnItem() {
      return this.actionsItem.filter(function (x) {
        return !!x.isDeleting || !!x.isUpdatingQuantity;
      }).length > 0;
    },
    isOrderForIndividualUs: function isOrderForIndividualUs() {
      var _this$order5, _this$order6;
      return ((_this$order5 = this.order) === null || _this$order5 === void 0 || (_this$order5 = _this$order5.delivery_address) === null || _this$order5 === void 0 ? void 0 : _this$order5.country.iso_2) === "US" && ((_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.user) === null || _this$order6 === void 0 ? void 0 : _this$order6.user_group) === "USER";
    }
  },
  created: function created() {
    this.currency = getIdCurrencyUsedForCartAndExplore();
    this.$EventBus.$on("add-item-to-cart", this.loadCurrentOrder);
    this.loadCurrentOrder();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$EventBus.$on("CurrencyUpdated", function (currency) {
      return _this2.currency = currency;
    });
    this.$EventBus.$on("update-cart", function () {
      return _this2.order = orderHandler.getCurrentOrder();
    });
    this.$EventBus.$on("BasketRemoved", function () {
      _this2.order.items = [];
    });
    this.$EventBus.$on("ItemRemoved", function (event) {
      var _event$detail;
      var items = Array.isArray(event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.items) ? event.detail.items : [];
      _this2.order.items = _toConsumableArray(items);
    });
  },
  methods: {
    loadCurrentOrder: function loadCurrentOrder() {
      var currentOrder = orderHandler.getCurrentOrder();
      var _this = this;
      if (!currentOrder && hasRole(process.env.VUE_APP_ROLES_BUYER)) {
        request("/v1/basket", "get", null, true, "api").then(function (response) {
          if (response.data) {
            var _this$order$items2;
            orderHandler.setCurrentOrder(response.data);
            _this.order = _objectSpread(_objectSpread({}, _this.order), response.data);
            if ((_this$order$items2 = _this.order.items) !== null && _this$order$items2 !== void 0 && _this$order$items2.length) {
              _this.countdownElapsed = orderHandler.isCountdownElapsed(_this.order.date_insert);
            }
          }
        });
      } else {
        var _this$order7;
        if (currentOrder) {
          this.order = _objectSpread(_objectSpread({}, this.order), currentOrder);
        }
        if ((_this$order7 = this.order) !== null && _this$order7 !== void 0 && (_this$order7 = _this$order7.items) !== null && _this$order7 !== void 0 && _this$order7.length) {
          this.countdownElapsed = orderHandler.isCountdownElapsed(this.order.date_insert);
        }
      }
    },
    shutCart: function shutCart() {
      this.$emit("shutCart", {
        force: true
      });
    },
    validateOrder: function validateOrder() {
      this.$router.push({
        name: "finalizeCart"
      });
      this.shutCart();
    },
    confirmDeleteItem: function confirmDeleteItem(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$refs.confirm.open("Delete", "Are you sure you want to remove this product ?", {
                color: "red"
              });
            case 2:
              confirmed = _context.sent;
              if (confirmed) {
                _this3.deleteItem(item);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteItem: function deleteItem(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, _yield$orderHandler$f, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this4.actionsItem.find(function (x) {
                return x.idItem == item.id_item;
              })) _this4.actionsItem.push({
                idItem: item.id_item,
                isUpdatingQuantity: false,
                isDeleting: true
              });
              _this = _this4;
              _context2.next = 4;
              return request("/v1/basket/items/".concat(item.id_item), "delete", {
                orderId: _this.order.id_order
              }, true, "api").catch(function (e) {
                _this4.actionsItem.find(function (x) {
                  return x.idItem == item.id_item;
                }).isDeleting = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to remove item", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              if (!(_this4.order.items.length === 1)) {
                _context2.next = 10;
                break;
              }
              //if it's the last item of cart, same as "EmptyCart"
              orderHandler.removeOrderFromStorage();
              _this4.$EventBus.$emit("BasketRemoved");
              _this4.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
              _context2.next = 17;
              break;
            case 10:
              _context2.next = 12;
              return orderHandler.fetchBasket();
            case 12:
              _yield$orderHandler$f = _context2.sent;
              data = _yield$orderHandler$f.data;
              _this4.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: data.items
                }
              });
              _this4.order = _objectSpread({}, data);
              orderHandler.setCurrentOrder(data);
            case 17:
              orderHandler.refreshCategoryUser(_this);
              _this4.actionsItem.find(function (x) {
                return x.idItem == item.id_item;
              }).isDeleting = false;
              _this4.$toasted.show("Product removed from your cart.", {
                type: "success"
              });
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    confirmEmptyBasket: function confirmEmptyBasket() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this5.$refs.confirm.open("Empty cart", "Are you sure you want to empty your cart ? All items will be removed.", {
                color: "red"
              });
            case 2:
              confirmed = _context3.sent;
              if (confirmed) {
                _this5.emptyBasket();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    emptyBasket: function emptyBasket() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.isRemovingCart = true;
              _this6.$EventBus.$emit("loading", true);
              _this = _this6;
              _context4.next = 5;
              return request("/v1/basket/" + _this.order.id_order, "delete", {
                orderId: _this.order.id_order
              }, true, "api").catch(function (e) {
                _this.isRemovingCart = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to empty cart.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              _this6.isRemovingCart = false;
              orderHandler.removeOrderFromStorage();
              _this6.$EventBus.$emit("BasketRemoved");
              _this6.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
              _this6.$toasted.show("Cart successfully emptied.", {
                type: "success"
              });
              orderHandler.refreshCategoryUser(_this);
              _this6.$EventBus.$emit("loading", false);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    casingsAvailable: function casingsAvailable(item) {
      var wineCasings = item.wine.casings.map(function (wc) {
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      });
      wineCasings.sort(function (a, b) {
        return a.quantity - b.quantity;
      });
      if (isAdminNotConsultant(this.loggedUserData) && !wineCasings.some(function (x) {
        return x.quantity == 1;
      })) {
        wineCasings.unshift(casingForAdmin());
      }
      return wineCasings;
    },
    changeQuantityOrder: function changeQuantityOrder(item, quantity) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var initialItem, casingIdInitial, quantityInitial, casing, quantityBeforeChange, originalIndex, _this, _yield$orderHandler$f2, data, _originalIndex, errorData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this7.actionsItem.find(function (x) {
                return x.idItem == item.id_item;
              })) _this7.actionsItem.push({
                idItem: item.id_item,
                isUpdatingQuantity: true,
                isDeleting: false
              });
              initialItem = _this7.order.items.find(function (x) {
                return x.id_item == item.id_item;
              });
              casingIdInitial = initialItem.originalCasingId;
              quantityInitial = initialItem.quantity; // Perform casing adjustment
              casing = item.casingId.match(/\d+/)[0];
              quantityBeforeChange = quantity;
              quantity = quantity * casing;
              item.quantity = quantity;
              item.total_amount = (item.quantity * item.unit_price).toFixed(2);
              if (item.quantity == 0) {
                // if the quantity of the item is down to 0, we delete the item of the cart and from the order
                originalIndex = _this7.order.items.indexOf(item);
                _this7.order.items.splice(originalIndex, 1);
                item._originalIndex = originalIndex;
              }
              _this = _this7;
              _context6.prev = 11;
              _context6.next = 14;
              return orderHandler.changeQuantity(_this.order.id_order, item.id_item, item.quantity, item.casingId, _this.$toasted).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
                  var _e$response;
                  var _e$response$data, value, isBypassingReachedBuyLimit, _value$errorMessage, errorMessage;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        item.quantity = quantityInitial;
                        item.casingId = casingIdInitial;
                        _e$response$data = (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data, value = _e$response$data.value;
                        isBypassingReachedBuyLimit = null;
                        if (!(value.errorCode === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context5.next = 10;
                          break;
                        }
                        _this.$toasted.clear();
                        errorMessage = (_value$errorMessage = value === null || value === void 0 ? void 0 : value.errorMessage) !== null && _value$errorMessage !== void 0 ? _value$errorMessage : value === null || value === void 0 ? void 0 : value.message;
                        _context5.next = 9;
                        return _this7.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 9:
                        isBypassingReachedBuyLimit = _context5.sent;
                      case 10:
                        if (!isBypassingReachedBuyLimit) {
                          _context5.next = 15;
                          break;
                        }
                        _context5.next = 13;
                        return request("/v1/order/".concat(_this.order.id_order, "/bypass"), "put", null, true, "api");
                      case 13:
                        _context5.next = 15;
                        return _this.changeQuantityOrder(item, quantityBeforeChange);
                      case 15:
                        _this.actionsItem.find(function (x) {
                          return x.idItem == item.id_item;
                        }).isUpdatingQuantity = false;
                        throw e;
                      case 17:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 14:
              _context6.next = 16;
              return orderHandler.fetchBasket();
            case 16:
              _yield$orderHandler$f2 = _context6.sent;
              data = _yield$orderHandler$f2.data;
              _this.order = _objectSpread({}, data);
              orderHandler.setCurrentOrder(_this.order);
              _this.actionsItem.find(function (x) {
                return x.idItem == item.id_item;
              }).isUpdatingQuantity = false;
              _this.$EventBus.$emit("update-cart");
              _this.$toasted.show("Quantity updated.", {
                type: "success"
              });
              _context6.next = 31;
              break;
            case 25:
              _context6.prev = 25;
              _context6.t0 = _context6["catch"](11);
              _originalIndex = item._originalIndex !== undefined ? item._originalIndex : _this7.order.items.length;
              if (!_this7.order.items.includes(item)) {
                _this7.order.items.splice(_originalIndex, 0, item);
              }
              errorData = getErrorData(_context6.t0, _this.managedExceptions, "Unable to change quantity");
              handleErrorData(_this, errorData, {
                showMessage: true
              });
            case 31:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[11, 25]]);
      }))();
    },
    formatPrice: formatPrice
  }
};